/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActiveBookingLookUpModel } from '../models/ActiveBookingLookUpModel';
import type { AdvisorAvailabilityModel } from '../models/AdvisorAvailabilityModel';
import type { BookingSummaryModel } from '../models/BookingSummaryModel';
import type { BranchType } from '../models/BranchType';
import type { CIFDto } from '../models/CIFDto';
import type { CIFFormModel } from '../models/CIFFormModel';
import type { CIFFormWithoutWipModel } from '../models/CIFFormWithoutWipModel';
import type { CIFModel } from '../models/CIFModel';
import type { CollectionDeliveryStatuses } from '../models/CollectionDeliveryStatuses';
import type { CreateAppointmentResponseDto } from '../models/CreateAppointmentResponseDto';
import type { CreateVehicleRequest } from '../models/CreateVehicleRequest';
import type { CustomerTypeSubmitModel } from '../models/CustomerTypeSubmitModel';
import type { DatePresetType } from '../models/DatePresetType';
import type { GetAppointmentResponse } from '../models/GetAppointmentResponse';
import type { RecalculatedServiceBookingPricesModel } from '../models/RecalculatedServiceBookingPricesModel';
import type { SearchAdvisorResponse } from '../models/SearchAdvisorResponse';
import type { ServiceAppointmentProductAvailableDTO } from '../models/ServiceAppointmentProductAvailableDTO';
import type { ServiceBookingAppointmentCreate } from '../models/ServiceBookingAppointmentCreate';
import type { ServiceBookingAppointmentCreateDto } from '../models/ServiceBookingAppointmentCreateDto';
import type { ServiceBookingAppointmentDatesModel } from '../models/ServiceBookingAppointmentDatesModel';
import type { ServiceBookingAppointmentRespDto } from '../models/ServiceBookingAppointmentRespDto';
import type { ServiceBookingAppointmentStatusEnum } from '../models/ServiceBookingAppointmentStatusEnum';
import type { ServiceBookingAppointmentUpdateDto } from '../models/ServiceBookingAppointmentUpdateDto';
import type { ServiceBookingCollectionDeliveryCheckPointDto } from '../models/ServiceBookingCollectionDeliveryCheckPointDto';
import type { ServiceBookingCollectionDeliveryDto } from '../models/ServiceBookingCollectionDeliveryDto';
import type { ServiceBookingCollectionDeliveryDtoPagedListData } from '../models/ServiceBookingCollectionDeliveryDtoPagedListData';
import type { ServiceBookingCollectionDeliveryUpdateDto } from '../models/ServiceBookingCollectionDeliveryUpdateDto';
import type { ServiceBookingDto } from '../models/ServiceBookingDto';
import type { ServiceBookingEditModel } from '../models/ServiceBookingEditModel';
import type { ServiceBookingEmailDto } from '../models/ServiceBookingEmailDto';
import type { ServiceBookingExistRecallJobModel } from '../models/ServiceBookingExistRecallJobModel';
import type { ServiceBookingInfoDto } from '../models/ServiceBookingInfoDto';
import type { ServiceBookingLoanCarResultDto } from '../models/ServiceBookingLoanCarResultDto';
import type { ServiceBookingNoteModel } from '../models/ServiceBookingNoteModel';
import type { ServiceBookingOptionsTimes } from '../models/ServiceBookingOptionsTimes';
import type { ServiceBookingPerfomanceDto } from '../models/ServiceBookingPerfomanceDto';
import type { ServiceBookingQualityCheckPointDto } from '../models/ServiceBookingQualityCheckPointDto';
import type { ServiceBookingQuickQuoteModel } from '../models/ServiceBookingQuickQuoteModel';
import type { ServiceBookingRecallJobModel } from '../models/ServiceBookingRecallJobModel';
import type { ServiceBookingRecallJobSubmitModel } from '../models/ServiceBookingRecallJobSubmitModel';
import type { ServiceBookingSentEmailModel } from '../models/ServiceBookingSentEmailModel';
import type { ServiceBookingTableDto } from '../models/ServiceBookingTableDto';
import type { ServiceBookingUpdateModel } from '../models/ServiceBookingUpdateModel';
import type { ServiceBookingWipDto } from '../models/ServiceBookingWipDto';
import type { UpdateBookingModel } from '../models/UpdateBookingModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ServiceBookingService {

  /**
   * @param page 
   * @param pageSize 
   * @param status 
   * @param from 
   * @param to 
   * @param branch 
   * @param userId 
   * @param bookingType 
   * @param bookingSource 
   * @param regNo 
   * @param bookingDateFrom 
   * @param bookingDateTo 
   * @param appointmentStatus
 *
 * 0 = OurAppointment
 *
 * 1 = InCdk
 *
 * 2 = ImportSoHeader
 *
 * 3 = HoursBooked
   * @param serviceBookingTransportOption 
   * @param wipNo 
   * @returns ServiceBookingTableDto Success
   * @throws ApiError
   */
  public static getServiceBooking(
page?: number,
pageSize?: number,
status?: number,
from?: string,
to?: string,
branch?: number,
userId?: number,
bookingType?: number,
bookingSource?: number,
regNo?: string,
bookingDateFrom?: string,
bookingDateTo?: string,
appointmentStatus?: ServiceBookingAppointmentStatusEnum,
serviceBookingTransportOption?: number,
wipNo?: number,
): CancelablePromise<ServiceBookingTableDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking',
      query: {
        'Page': page,
        'PageSize': pageSize,
        'Status': status,
        'From': from,
        'To': to,
        'Branch': branch,
        'UserId': userId,
        'BookingType': bookingType,
        'BookingSource': bookingSource,
        'RegNo': regNo,
        'BookingDateFrom': bookingDateFrom,
        'BookingDateTo': bookingDateTo,
        'AppointmentStatus': appointmentStatus,
        'ServiceBookingTransportOption': serviceBookingTransportOption,
        'WipNo': wipNo,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postServiceBooking(
requestBody?: ServiceBookingEditModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteServiceBooking(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-booking/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns ServiceBookingDto Success
   * @throws ApiError
   */
  public static getServiceBooking1(
id: number,
): CancelablePromise<ServiceBookingDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static putServiceBooking(
id: number,
requestBody?: ServiceBookingEditModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/service-booking/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static patchServiceBooking(
id: number,
requestBody?: ServiceBookingUpdateModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/service-booking/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static patchServiceBookingSelectedPrices(
id: number,
requestBody?: ServiceBookingUpdateModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/service-booking/{id}/selected-prices',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns RecalculatedServiceBookingPricesModel Success
   * @throws ApiError
   */
  public static postServiceBookingRecalculatePrices(
id: number,
requestBody?: number,
): CancelablePromise<RecalculatedServiceBookingPricesModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/{id}/recalculate-prices',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns ServiceBookingWipDto Success
   * @throws ApiError
   */
  public static getServiceBookingWip(
id: number,
): CancelablePromise<ServiceBookingWipDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/wip/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postServiceBookingWip(
id: number,
requestBody?: number,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/wip/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param branchId 
   * @param vin 
   * @param regno 
   * @param vehicleId 
   * @param sbookingId 
   * @returns any Success
   * @throws ApiError
   */
  public static getServiceBookingContracts(
branchId?: number,
vin?: string,
regno?: string,
vehicleId?: string,
sbookingId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/contracts',
      query: {
        'branchId': branchId,
        'vin': vin,
        'regno': regno,
        'vehicleId': vehicleId,
        'sbookingId': sbookingId,
      },
    });
  }

  /**
   * @param email 
   * @param regno 
   * @param id 
   * @returns number Success
   * @throws ApiError
   */
  public static getServiceBookingVauchers(
email?: string,
regno?: string,
id?: number,
): CancelablePromise<Array<number>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/vauchers',
      query: {
        'email': email,
        'regno': regno,
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param branchId 
   * @param dateFrom 
   * @returns ServiceBookingLoanCarResultDto Success
   * @throws ApiError
   */
  public static getServiceBookingLoanVehicles(
branchId?: number,
dateFrom?: string,
): CancelablePromise<ServiceBookingLoanCarResultDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/loan-vehicles',
      query: {
        'branchId': branchId,
        'dateFrom': dateFrom,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postServiceBookingQuickQuote(
id: number,
requestBody?: ServiceBookingQuickQuoteModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/{id}/quick-quote',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param datePreset
 *
 * 0 = Period
 *
 * 1 = Day
 *
 * 2 = Week
 *
 * 3 = Month
   * @param dateFrom 
   * @param dateTo 
   * @param branchId 
   * @param departmentId 
   * @param employeeName 
   * @returns ServiceBookingPerfomanceDto Success
   * @throws ApiError
   */
  public static getServiceBookingPerfomance(
datePreset: DatePresetType,
dateFrom?: string,
dateTo?: string,
branchId?: number,
departmentId?: number,
employeeName?: string,
): CancelablePromise<ServiceBookingPerfomanceDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/perfomance',
      query: {
        'datePreset': datePreset,
        'dateFrom': dateFrom,
        'dateTo': dateTo,
        'branchId': branchId,
        'departmentId': departmentId,
        'employeeName': employeeName,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postServiceBookingNotes(
id: number,
requestBody?: ServiceBookingNoteModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/{id}/notes',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static postServiceBookingSetCompleted(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/set-completed',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postServiceBookingSetManualDeleted(
id: number,
requestBody?: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/{id}/set-manual-deleted',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns ServiceBookingEmailDto Success
   * @throws ApiError
   */
  public static getServiceBookingEmailInfo(
id?: number,
): CancelablePromise<ServiceBookingEmailDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/email-info',
      query: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns ServiceBookingEmailDto Success
   * @throws ApiError
   */
  public static getServiceBookingEmailPreview(
id: number,
): CancelablePromise<ServiceBookingEmailDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/{id}/email-preview',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postServiceBookingSendEmail(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/{id}/send-email',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postServiceBookingSaveEmailConfirmation(
id?: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/save-email-confirmation',
      query: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postServiceBookingSaveEmail(
requestBody?: ServiceBookingSentEmailModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/save-email',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postServiceBookingFormCif(
requestBody?: CIFFormModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/form-cif',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postServiceBookingFormCifWithoutWip(
requestBody?: CIFFormWithoutWipModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/form-cif-without-wip',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns CIFDto Success
   * @throws ApiError
   */
  public static getServiceBookingCif(
id?: number,
): CancelablePromise<CIFDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/cif',
      query: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postServiceBookingCif(
requestBody?: CIFModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/cif',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteServiceBookingDeleteCifFilled(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-booking/delete-cif-filled/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dateFrom 
   * @param dateTo 
   * @returns string Success
   * @throws ApiError
   */
  public static getServiceBookingExport(
dateFrom?: string,
dateTo?: string,
): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/export',
      query: {
        'dateFrom': dateFrom,
        'dateTo': dateTo,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static getServiceBookingAdditionalWorks(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/additional-works',
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static getServiceBookingEmailHistory(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/{id}/email-history',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param branchId 
   * @returns SearchAdvisorResponse Success
   * @throws ApiError
   */
  public static getServiceBookingAdvisors(
branchId?: number,
): CancelablePromise<SearchAdvisorResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/advisors',
      query: {
        'branchId': branchId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param branchId 
   * @param dateFrom 
   * @param dateTo 
   * @returns AdvisorAvailabilityModel Success
   * @throws ApiError
   */
  public static getServiceBookingMultipleAdvisors(
branchId?: number,
dateFrom?: string,
dateTo?: string,
): CancelablePromise<AdvisorAvailabilityModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/multiple-advisors',
      query: {
        'branchId': branchId,
        'dateFrom': dateFrom,
        'dateTo': dateTo,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param branchId 
   * @param optionGuid 
   * @param date 
   * @returns ServiceAppointmentProductAvailableDTO Success
   * @throws ApiError
   */
  public static getServiceBookingAvailabilityCombined(
id?: number,
branchId?: number,
optionGuid?: string,
date?: string,
): CancelablePromise<Array<ServiceAppointmentProductAvailableDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/availability/combined',
      query: {
        'id': id,
        'branchId': branchId,
        'optionGuid': optionGuid,
        'date': date,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param branchId 
   * @param optionGuid 
   * @param date 
   * @returns ServiceAppointmentProductAvailableDTO Success
   * @throws ApiError
   */
  public static getServiceBookingAvailabilityTransportOptions(
branchId?: number,
optionGuid?: string,
date?: string,
): CancelablePromise<Array<ServiceAppointmentProductAvailableDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/availability/transport-options',
      query: {
        'branchId': branchId,
        'optionGuid': optionGuid,
        'date': date,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param branchId 
   * @param id 
   * @param date 
   * @returns ServiceAppointmentProductAvailableDTO Success
   * @throws ApiError
   */
  public static getServiceBookingAvailabilityServiceProductsByRecord(
branchId?: number,
id?: number,
date?: string,
): CancelablePromise<Array<ServiceAppointmentProductAvailableDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/availability/service-products/by-record',
      query: {
        'branchId': branchId,
        'id': id,
        'date': date,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param branchId 
   * @param serviceProductGuids 
   * @param date 
   * @returns ServiceAppointmentProductAvailableDTO Success
   * @throws ApiError
   */
  public static getServiceBookingAvailabilityServiceProducts(
branchId?: number,
serviceProductGuids?: Array<string>,
date?: string,
): CancelablePromise<Array<ServiceAppointmentProductAvailableDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/availability/service-products',
      query: {
        'branchId': branchId,
        'serviceProductGuids': serviceProductGuids,
        'date': date,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns GetAppointmentResponse Success
   * @throws ApiError
   */
  public static getServiceBookingAppointments(
id: number,
): CancelablePromise<GetAppointmentResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/{id}/appointments',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param userId 
   * @returns void 
   * @throws ApiError
   */
  public static deleteServiceBookingAppointments(
id: number,
userId: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-booking/{id}/appointments',
      path: {
        'id': id,
      },
      query: {
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns CreateAppointmentResponseDto Created
   * @throws ApiError
   */
  public static postServiceBookingAppointments(
requestBody?: ServiceBookingAppointmentCreate,
): CancelablePromise<CreateAppointmentResponseDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/appointments',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns void 
   * @throws ApiError
   */
  public static deleteServiceBookingAppointmentsWithoutUser(
id: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-booking/{id}/appointments/without-user',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Created
   * @throws ApiError
   */
  public static postServiceBookingCdkCustomerVehicle(
requestBody?: CreateVehicleRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/cdk-customer-vehicle',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param regNo 
   * @param mileage 
   * @returns any Created
   * @throws ApiError
   */
  public static postServiceBookingCdkCustomerVehicleViaUkVehicleData(
regNo?: string,
mileage?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/cdk-customer-vehicle-via-uk-vehicle-data',
      query: {
        'regNo': regNo,
        'mileage': mileage,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param branchId 
   * @param regNo 
   * @returns ServiceBookingInfoDto Success
   * @throws ApiError
   */
  public static getBookingInfo(
branchId?: number,
regNo?: string,
): CancelablePromise<Array<ServiceBookingInfoDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/booking-info',
      query: {
        'branchId': branchId,
        'regNo': regNo,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param branchId 
   * @param id 
   * @param optionGuid 
   * @param date 
   * @returns ServiceAppointmentProductAvailableDTO Success
   * @throws ApiError
   */
  public static getServiceBookingAvailabilitySlots(
branchId?: number,
id?: number,
optionGuid?: string,
date?: string,
): CancelablePromise<Array<ServiceAppointmentProductAvailableDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/availability/slots',
      query: {
        'branchId': branchId,
        'id': id,
        'optionGuid': optionGuid,
        'date': date,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns CreateAppointmentResponseDto Created
   * @throws ApiError
   */
  public static postServiceBookingAppointmentsUpdate(
requestBody?: UpdateBookingModel,
): CancelablePromise<CreateAppointmentResponseDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/appointments/update',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns string Created
   * @throws ApiError
   */
  public static postServiceBookingAppointmentsWebClient(
id: number,
): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/appointments/{id}/web-client',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postServiceBookingCustomerType(
requestBody?: CustomerTypeSubmitModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/customer-type',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postServiceBookingBookingDates(
id: number,
requestBody?: ServiceBookingAppointmentDatesModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/{id}/booking-dates',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param regNo 
   * @returns ActiveBookingLookUpModel Success
   * @throws ApiError
   */
  public static getServiceBookingActiveBookingsByRegno(
regNo?: string,
): CancelablePromise<ActiveBookingLookUpModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/active-bookings-by-regno',
      query: {
        'regNo': regNo,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param wipNo 
   * @param regNo 
   * @returns BookingSummaryModel Success
   * @throws ApiError
   */
  public static getServiceBookingSummary(
wipNo?: number,
regNo?: string,
): CancelablePromise<BookingSummaryModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/summary',
      query: {
        'wipNo': wipNo,
        'regNo': regNo,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param recallCode 
   * @param userId 
   * @param recallBrand 
   * @returns ServiceBookingRecallJobModel Success
   * @throws ApiError
   */
  public static getServiceBookingRecallJob(
recallCode?: string,
userId?: number,
recallBrand?: number,
): CancelablePromise<Array<ServiceBookingRecallJobModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/recall-job',
      query: {
        'recallCode': recallCode,
        'userId': userId,
        'recallBrand': recallBrand,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Created
   * @throws ApiError
   */
  public static postServiceBookingRecallJob(
id: number,
requestBody?: Array<ServiceBookingRecallJobSubmitModel>,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/{id}/recall-job',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putServiceBookingRecallJob(
id: number,
requestBody?: Array<ServiceBookingRecallJobSubmitModel>,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/service-booking/{id}/recall-job',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteServiceBookingRecallJob(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-booking/{id}/recall-job',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param userId 
   * @param requestBody 
   * @returns boolean Created
   * @throws ApiError
   */
  public static postServiceBookingSaveAndSubmitRecallJob(
id: number,
userId?: number,
requestBody?: Array<ServiceBookingRecallJobSubmitModel>,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/{id}/save-and-submit-recall-job',
      path: {
        'id': id,
      },
      query: {
        'userId': userId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteServiceBookingRecallJobLabour(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-booking/{id}/recall-job-labour',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteServiceBookingRecallJobPart(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-booking/{id}/recall-job-part',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns ServiceBookingExistRecallJobModel Success
   * @throws ApiError
   */
  public static getServiceBookingExistingRecallJobs(
id: number,
): CancelablePromise<Array<ServiceBookingExistRecallJobModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/{id}/existing-recall-jobs',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param userId 
   * @returns boolean Created
   * @throws ApiError
   */
  public static postServiceBookingServiceBookingHoursBookedAvailability(
id: number,
userId?: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/{id}/service-booking-hours-booked-availability',
      path: {
        'id': id,
      },
      query: {
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param serviceBookingId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postServiceBookingServiceBookingAppointments(
serviceBookingId: number,
requestBody?: ServiceBookingAppointmentCreateDto,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/{serviceBookingId}/service-booking-appointments',
      path: {
        'serviceBookingId': serviceBookingId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param serviceBookingId 
   * @returns ServiceBookingAppointmentRespDto Success
   * @throws ApiError
   */
  public static getServiceBookingServiceBookingAppointments(
serviceBookingId: number,
): CancelablePromise<Array<ServiceBookingAppointmentRespDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/{serviceBookingId}/service-booking-appointments',
      path: {
        'serviceBookingId': serviceBookingId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param serviceBookingId 
   * @returns ServiceBookingAppointmentRespDto Success
   * @throws ApiError
   */
  public static getServiceBookingServiceBookingAppointmentsInfo(
serviceBookingId: number,
): CancelablePromise<Array<ServiceBookingAppointmentRespDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/{serviceBookingId}/service-booking-appointments/info',
      path: {
        'serviceBookingId': serviceBookingId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param appointmentId 
   * @returns ServiceBookingAppointmentRespDto Success
   * @throws ApiError
   */
  public static getServiceBookingServiceBookingAppointments1(
appointmentId: number,
): CancelablePromise<ServiceBookingAppointmentRespDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/service-booking-appointments/{appointmentId}',
      path: {
        'appointmentId': appointmentId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param appointmentId 
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static putServiceBookingServiceBookingAppointments(
appointmentId: number,
requestBody?: ServiceBookingAppointmentUpdateDto,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/service-booking/service-booking-appointments/{appointmentId}',
      path: {
        'appointmentId': appointmentId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param appointmentId 
   * @returns void 
   * @throws ApiError
   */
  public static deleteServiceBookingServiceBookingAppointments(
appointmentId: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-booking/service-booking-appointments/{appointmentId}',
      path: {
        'appointmentId': appointmentId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param collectionDeliveryId 
   * @returns ServiceBookingCollectionDeliveryDto Success
   * @throws ApiError
   */
  public static getServiceBookingCollectionDeliveries(
collectionDeliveryId: number,
): CancelablePromise<ServiceBookingCollectionDeliveryDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/collection-deliveries/{collectionDeliveryId}',
      path: {
        'collectionDeliveryId': collectionDeliveryId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param collectionDeliveryId 
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static putServiceBookingCollectionDeliveries(
collectionDeliveryId: number,
requestBody?: ServiceBookingCollectionDeliveryUpdateDto,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/service-booking/collection-deliveries/{collectionDeliveryId}',
      path: {
        'collectionDeliveryId': collectionDeliveryId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param collectionDeliveryId 
   * @returns void 
   * @throws ApiError
   */
  public static deleteServiceBookingCollectionDeliveries(
collectionDeliveryId: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-booking/collection-deliveries/{collectionDeliveryId}',
      path: {
        'collectionDeliveryId': collectionDeliveryId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dateFrom 
   * @param dateTo 
   * @param regNo 
   * @param paginationSkipPagination Пропустить пагинацию
   * @param paginationPage Страница
   * @param paginationMaxCount Максимально количество записей на странице
   * @param branchId 
   * @returns ServiceBookingCollectionDeliveryDtoPagedListData Success
   * @throws ApiError
   */
  public static getServiceBookingCollectionDeliveries1(
dateFrom?: string,
dateTo?: string,
regNo?: string,
paginationSkipPagination?: boolean,
paginationPage?: number,
paginationMaxCount?: number,
branchId?: number,
): CancelablePromise<ServiceBookingCollectionDeliveryDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/collection-deliveries',
      query: {
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'RegNo': regNo,
        'Pagination.SkipPagination': paginationSkipPagination,
        'Pagination.Page': paginationPage,
        'Pagination.MaxCount': paginationMaxCount,
        'BranchId': branchId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param collectionDeliveryId 
   * @param status
 *
 * 10 = Started
 *
 * 20 = Collected
 *
 * 30 = DeliveredToTheBranch
 *
 * 40 = QualityCheck
 *
 * 50 = CollectedFromBranch
 *
 * 60 = ReturnedToCustomer
 *
 * 70 = ReturnedToBranch
   * @returns void 
   * @throws ApiError
   */
  public static putServiceBookingCollectionDeliveriesStatuses(
collectionDeliveryId: number,
status?: CollectionDeliveryStatuses,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/service-booking/collection-deliveries/{collectionDeliveryId}/statuses',
      path: {
        'collectionDeliveryId': collectionDeliveryId,
      },
      query: {
        'status': status,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param collectionDeliveryId 
   * @param status
 *
 * 10 = Started
 *
 * 20 = Collected
 *
 * 30 = DeliveredToTheBranch
 *
 * 40 = QualityCheck
 *
 * 50 = CollectedFromBranch
 *
 * 60 = ReturnedToCustomer
 *
 * 70 = ReturnedToBranch
   * @returns void 
   * @throws ApiError
   */
  public static deleteServiceBookingCollectionDeliveriesStatuses(
collectionDeliveryId: number,
status?: CollectionDeliveryStatuses,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-booking/collection-deliveries/{collectionDeliveryId}/statuses',
      path: {
        'collectionDeliveryId': collectionDeliveryId,
      },
      query: {
        'status': status,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param collectionDeliveryId 
   * @returns void 
   * @throws ApiError
   */
  public static postServiceBookingCollectionDeliveriesStatusesDistance(
collectionDeliveryId: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/collection-deliveries/{collectionDeliveryId}/statuses/distance',
      path: {
        'collectionDeliveryId': collectionDeliveryId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param collectionDeliveryId 
   * @returns ServiceBookingQualityCheckPointDto Success
   * @throws ApiError
   */
  public static getServiceBookingCollectionDeliveriesQualityCheckPoints(
collectionDeliveryId: number,
): CancelablePromise<Array<ServiceBookingQualityCheckPointDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/collection-deliveries/{collectionDeliveryId}/quality-check-points',
      path: {
        'collectionDeliveryId': collectionDeliveryId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param collectionDeliveryId 
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static putServiceBookingCollectionDeliveriesQualityCheckPoints(
collectionDeliveryId: number,
requestBody?: Array<ServiceBookingCollectionDeliveryCheckPointDto>,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/service-booking/collection-deliveries/{collectionDeliveryId}/quality-check-points',
      path: {
        'collectionDeliveryId': collectionDeliveryId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param collectionDeliveryId 
   * @param checkPointId 
   * @returns void 
   * @throws ApiError
   */
  public static deleteServiceBookingCollectionDeliveriesQualityCheckPoints(
collectionDeliveryId: number,
checkPointId: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-booking/collection-deliveries/{collectionDeliveryId}/quality-check-points/{checkPointId}',
      path: {
        'collectionDeliveryId': collectionDeliveryId,
        'checkPointId': checkPointId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param customerId 
   * @returns number Success
   * @throws ApiError
   */
  public static getServiceBookingContactImport(
branch?: BranchType,
customerId?: string,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/contact-import',
      query: {
        'branch': branch,
        'customerId': customerId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param vehicleId 
   * @returns number Success
   * @throws ApiError
   */
  public static getServiceBookingVehicleImport(
branch?: BranchType,
vehicleId?: string,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/vehicle-import',
      query: {
        'branch': branch,
        'vehicleId': vehicleId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns ServiceBookingOptionsTimes Success
   * @throws ApiError
   */
  public static getServiceBookingGetServiceBookingOptionTimes(
id: number,
): CancelablePromise<ServiceBookingOptionsTimes> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/{id}/get-service-booking-option-times',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static postServiceBookingCreateServiceBookingHoursBookedAvailability(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/{id}/create-service-booking-hours-booked-availability',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static postServiceBookingCreateAppointmentsByFoundsAppointmentsInCdk(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/create-appointments-by-founds-appointments-in-cdk',
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static postServiceBookingCreateAppointmentsByFoundsAppointmentsInCdkScheduleHours(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/create-appointments-by-founds-appointments-in-cdk-schedule-hours',
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static postServiceBookingCreateServiceBookingAppointmentInCdk(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/{id}/create-service-booking-appointment-in-cdk',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static postServiceBookingCreateSoHeaderByAppointment(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking/{id}/create-so-header-by-appointment',
      path: {
        'id': id,
      },
    });
  }

}
